module.exports = __webpack_public_path__ + "static/media/m120-53.cec8f5f1.png";